export const isValidUrl = (urlString: string) => {
	try {
		return Boolean(new URL(urlString));
	} catch (e) {
		return false;
	}
};

// needed when the URL is relative and the user has used the portal switcher
export const addDomainToUrlIfNeeded = (url: string, domain?: string) => {
	const hasProtocol = /^https?:\/\//i.test(url);

	if (!hasProtocol && domain) {
		return `https://${domain}${url}`;
	}

	return url;
};
